'use client'
import { MultiSelectFormListStringFieldOneLineUiTest } from '@repo/ui'
import { useRouter, useSearchParams, usePathname } from 'next/navigation'

export default function IndustryFilterClient({ options, value }: { options: string[]; value: string[] }) {
  const router = useRouter()
  const search = useSearchParams()
  const pathname = usePathname()

  const setValue = (next: string[]) => {
    const p = new URLSearchParams(search.toString())
    next.length ? p.set('Industry', next.join(',')) : p.delete('Industry')
    router.push(`${pathname}?${p}`, { scroll: false })
  }

  return (
    <MultiSelectFormListStringFieldOneLineUiTest
      options={options}
      defaultValue={value}
      onValueChange={setValue}
      placeholder="Industry"
      className="max-w-[280px]"
      popoverContentClassName="min-w-[348px]"
    />
  )
}
